module.exports = __webpack_public_path__ + "img/vi.e652f837.png";